import { ButtonBase } from "@mui/material";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import { ChevronDown } from "mdi-material-ui";
import React from "react";

// "Show 7 more reels" under a paged section; hidden once everything is loaded.
export default function ShowMoreButton({ remaining, noun, onClick, disabled = false }) {
  if (remaining <= 0) return null;

  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        alignSelf: "flex-start",
        gap: 4,
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontSize: "0.8rem",
        fontWeight: 400,
        color: "#9e9e9e",
        padding: `${SPACING} 0`,
      }}
    >
      <ChevronDown style={{ fontSize: "1.2em" }} />
      {`Show ${remaining} more ${noun}${remaining === 1 ? "" : "s"}`}
    </ButtonBase>
  );
}
